export default {"src":"/_next/static/media/businessTakeProactive.40a58285.svg","height":30,"width":36,"blurWidth":0,"blurHeight":0};